import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { ALL } from "../../constant/constants";
import { visibleAssignSection } from "../../utils/general";
import { useSelector } from "react-redux";

const { SimList } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ResourceSidebar = ({ UNO_URL, onHandleSelectTab, UUID, checkBoxAll, setCheckBoxAll, handleSelectAllTrigger }) => {
  const userData = useUnoSelector((state) => state.user);
  const filterOptions = useSelector(state => state.filterOptions)
  const [resourceItems, setResourceItems] = useState([]);

  useEffect(() => {
    setResourceItems(visibleAssignSection(filterOptions.total))
  }, [filterOptions, filterOptions.total]);

  const handleToggleAll = (e) => {

  }

  console.log("resourceItems", resourceItems);
  return (
    <div style={{ position: "sticky", top: "100px" }}>
      {resourceItems.length > 0 && (
        <>
          {/* <button className="normalbtn d-flex align-items-center mb-2">
            <SimCheckBox checked={checkBoxAll[ALL]} onChange={handleToggleAll} /> Select All
          </button> */}
          <SimList resourceItems={resourceItems} onItemClick={onHandleSelectTab} listIcon={true} counts={true} />
        </>
      )}

    </div>
  );
};

ResourceSidebar.propTypes = {
  onHandleSelectTab: PropTypes.func.isRequired,
};

export default ResourceSidebar;
